import { render, staticRenderFns } from "./lk-mobile-notify.vue?vue&type=template&id=221bb673&"
import script from "./lk-mobile-notify.vue?vue&type=script&lang=js&"
export * from "./lk-mobile-notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-mobile-notify.vue
// module id = 1406
// module chunks = 0